import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`


/* variables (imutables)*/
:root {
    --black: #000;
    --white: #fff;
    --bodyBg: #fff;
    --accent: #82b224;
    --primary: #B4D984;
    --primary-light: #D9ECC1;
    --primary-dark: #6D942E;
    --primary-hyperlink: #5f7141;
    --hyperlink: #8A4E3C;
    --gray: #EEF0F5;
    --secondary: #FF8469;
    --success: #74CB72;

}

/* ____  reset   ____ */
*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  font-family: inherit;
}
*:focus {
    outline: none;
}
html {
    font-size: 62.5%;
    -webkit-text-size-adjust: 100%;
}

body {
    background: var(--bodyBg);
    scroll-behavior: smooth;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    overflow-y: overlay;
    overscroll-behavior-y: contain;
    &.fixed {
       overflow: hidden;
    }
}

/*  typography */


body {
    font-family: 'frutiger';
    font-weight: 400;
    line-height: 1.3;
    color: var(--textDark);
    font-size: 14px;
}

h4,h5,h6 {
    font-weight: normal;
}

h1,h2,h3,h4,h5 {
    text-transform: capitalize;
    font-family: inherit;
}

p {
    line-height: 1.5;
}

/* normalize / reset */
main { display: block;}
ul,li { list-style: none;}

a, a:visited, a:hover, a:active, a:focus, button {
    outline: none;
    font-family: inherit;
}
a {
    text-decoration: none;
    color: inherit;
    font-family: inherit;
    font-size: 12px;
}
button {
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 12px;
    font-family: inherit;
}
// for safari - on mobile repaint colors
@media screen and (max-width: 768px) {
    button,a {
        color: inherit;
    }
    button svg, a svg {
        color: inherit;
    }
}
input,textarea,select {
    outline: none;
    font-family: inherit;
}
textarea {
    resize: vertical;
}

img {
    display: block;
    height: auto;
    max-width: 100%;
    max-height: 100%;
}
svg {
    display: inline-flex;
    width: auto;
    height: auto;
}

/* -----  Text Selection  -------- */
::-moz-selection {
  background: #b3d4fc;
    text-shadow: none;
    color: #111;
}
::selection {
    background: var(--primary);
    text-shadow: none;
    color: #000;
}


/* input type number - arrs : Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

/*  -------- scroll bar -------- */
/* total width */
body::-webkit-scrollbar {
    background-color: #fff;
    width: 8px;
    position: relative;
    background-color: transparent;
}

/* background of the scrollbar except button or resizer */
body::-webkit-scrollbar-track {
    background-color: transparent;
}

/* scrollbar itself */
body::-webkit-scrollbar-thumb {
    cursor: pointer;
    transition: .4s;
    background-color: rgba(0,0,0, .4);
    border-radius: 4px;
    border-right: 1px solid #fff;
    //border-top: .5px solid #fff;
}
body::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0,0,0, .6);
}
/* set button(top and bottom of the scrollbar) */
body::-webkit-scrollbar-button {
    display:none;
}

/* // TEXT size adjust */
* {
 -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
   -ms-text-size-adjust: none;
      text-size-adjust: none;
}




/*  ----- utility classes ----- */
.invisible {
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
}
.no-link {
    pointer-events: none;
    cursor: default;
}

// fix autofill styles for input
input:-webkit-autofill,
input:-webkit-autofill:focus {
    transition: background-color 600000s 0s, color 600000s 0s;
}


`;

// ________________________________________
export default GlobalStyle;
